<div class="verification-container">
  <!-- Loading Overlay -->
  @if (loading() || sendingOtp()) {
    <div class="loading-overlay">
      <div class="spinner-container">
        <div class="rolling-circle">
          <div class="circle"></div>
        </div>
        <p class="loading-text">
          @if (sendingOtp()) {
            Sending verification code...
          } @else {
            Verifying your email...
          }
        </p>
      </div>
    </div>
  }

  <div class="verification-card">
    <!-- Header -->
    <div class="auth-header">
      <h1 class="auth-title">Verify Your Email</h1>
      <p class="auth-subtitle">We've sent a verification code to your email address</p>
    </div>

    <!-- Email Verification Form -->
    <form (ngSubmit)="verifyOtp()" class="auth-form">
      <!-- Email Input (if not provided) -->
      @if (!email()) {
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <input
            type="email"
            id="email"
            pInputText
            [(ngModel)]="email"
            name="email"
            placeholder="john.doe@example.com"
            class="form-input"
            autocomplete="email"
            required
          />
        </div>
      } @else {
        <div class="email-display">
          <i class="pi pi-envelope"></i>
          <span>{{ email() }}</span>
        </div>
      }

      <!-- OTP Input -->
      <div class="form-group">
        <label for="otp" class="form-label">Verification Code</label>
        <input
          type="text"
          id="otp"
          pInputText
          [(ngModel)]="otp"
          name="otp"
          placeholder="Enter 6-digit code"
          class="form-input otp-input"
          maxlength="6"
          pattern="[0-9]*"
          inputmode="numeric"
          autocomplete="one-time-code"
          required
        />
        <p class="form-hint">Enter the 6-digit code sent to your email</p>
      </div>

      <!-- Countdown Timer -->
      @if (countdown() > 0) {
        <div class="countdown">
          <i class="pi pi-clock"></i>
          <span>Code expires in {{ formatCountdown(countdown()) }}</span>
        </div>
      } @else if (expiresAt() && countdown() === 0) {
        <div class="countdown expired">
          <i class="pi pi-exclamation-triangle"></i>
          <span>Code has expired. Please request a new one.</span>
        </div>
      }

        <button
        type="submit"
        pButton
        label="Verify Email"
        icon="pi pi-check"
        [loading]="loading()"
        [disabled]="!otp() || otp().length !== 6"
        class="submit-button"
      ></button>

      <!-- Resend OTP -->
      <div class="resend-section">
        <p class="resend-text">Didn't receive the code?</p>
        <button
          type="button"
          pButton
          label="Resend Code"
          icon="pi pi-refresh"
          [loading]="sendingOtp()"
          [disabled]="sendingOtp() || countdown() > 0"
          (click)="sendOtp()"
          class="resend-button p-button-text"
        ></button>
      </div>

      <div class="auth-footer">
        <p>
          Already verified?
          <a routerLink="/signin" class="auth-link">Sign in here</a>
        </p>
      </div>
    </form>
  </div>
  
  <!-- Toast Notifications -->
  <p-toast position="bottom-right"></p-toast>
</div>
